<template>
  <div class="verify-container">
    <div v-if="verified==1" class="verify-slider">
      <div class="slider-track" @click="verifySuccess">请点击按钮进行验证</div>
<!--      <div-->
<!--        class="slider-button"-->
<!--        @mousedown="startDrag"-->
<!--        @touchstart="startDrag"-->
<!--      >-->
<!--        →-->
<!--      </div>-->
    </div>
    <div v-else-if="verified==2" class="verify-loding">
      <i class="el-icon-loading"></i> 等待验证
    </div>
    <div v-else class="verify-success">
      <i class="el-icon-success"></i> 验证成功
    </div>
  </div>
</template>

<script>
export default {
  props: {
    verified: {
      default: 1,
      type: Number // 1带验证 2验证中 3验证通过
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      currentX: 0
    }
  },
  methods: {
    startDrag(e) {
      this.isDragging = true
      this.startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
      document.addEventListener('touchend', this.endDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return

      const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX
      this.currentX = clientX - this.startX

      const slider = this.$el.querySelector('.verify-slider')
      const maxX = slider.offsetWidth - 40 // 40是按钮宽度

      if (this.currentX >= maxX) {
        this.currentX = maxX
        this.endDrag()
        this.verifySuccess()
      }

      const button = this.$el.querySelector('.slider-button')
      button.style.transform = `translateX(${this.currentX}px)`
    },
    endDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
      document.removeEventListener('touchend', this.endDrag)

      // 如果未验证成功，复位按钮
      if (this.verified!=2) {
        const button = this.$el.querySelector('.slider-button')
        button.style.transform = 'translateX(0)'
      }
    },
    verifySuccess () {
      this.verified = 2
      this.$emit('success') // 触发成功事件
    }
  }
}
</script>

<style scoped>
.verify-container {
  width: 100%;
  margin: 0px 0;
}

.verify-slider {
  position: relative;
  width: 100%;
  height: 30px;
  background: #e8f0fe;
  border-radius: 4px;
  overflow: hidden;
  /*border: 1px solid #9a9999;*/
}

.slider-track {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  line-height: 30px;
  text-align: center;
  color: #909399;
}

.slider-button {
  position: absolute;
  width: 40px;
  height: 30px;
  background: #409EFF;
  color: white;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 1;
  user-select: none;
}

.verify-loding {
  color: #9a9999;
  height: 30px;
  text-align: center;
  font-size: 14px;
}

.verify-success {
  color: #67C23A;
  text-align: center;
  font-size: 14px;
  height: 30px;
}

.verify-success i {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/verifition/Captcha.vue